export default __webpack_public_path__ + "static/media/s4.e99ab6ee.png";